import { useEffect, useState } from 'react';
import { useAPIContext } from '../../../../components/Context';
import { useCallbackRef } from '../../../../utils';
import { useAuthorizationState } from '../authorization/hooks';
import { createAsyncState } from '../hooks';
export var useHistoryListAsync = createAsyncState('historyList');
export var useHistoryItemAsync = createAsyncState('historyItem');
export var useHistoryListQuery = function () {
    var _a;
    var _b = useHistoryListAsync(), asyncState = _b[0], actions = _b[1];
    var api = useAPIContext();
    var isAuthorized = ((_a = useAuthorizationState().data) === null || _a === void 0 ? void 0 : _a.authorization_status) === 'authorized';
    var historyList = isAuthorized ? api.historyList : undefined;
    useEffect(function () {
        if (historyList) {
            actions.start();
            return historyList({
                body: {
                    services: {
                        taxi: {
                            image_tags: {
                                size_hint: 9999,
                            },
                        },
                    },
                    range: {
                        results: 20,
                    },
                    include_service_metadata: true,
                },
                onError: actions.error,
                onSuccess: actions.success,
            });
        }
    }, [actions, historyList]);
    return asyncState;
};
export var useHistoryItemQuery = function (id) {
    var _a = useHistoryItemAsync(), asyncState = _a[0], actions = _a[1];
    var historyItem = useAPIContext().historyItem;
    useEffect(function () {
        if (historyItem) {
            actions.start();
            return historyItem({
                body: {
                    service: 'taxi',
                    order_id: id,
                    service_request: {
                        taxi: {
                            image_tags: {
                                size_hint: 9999,
                            },
                        },
                    },
                },
                onError: actions.error,
                onSuccess: actions.success,
            });
        }
    }, [actions, historyItem, id]);
    return asyncState;
};
export var useHistoryItemRequest = function (orderId) {
    var historyItem = useAPIContext().historyItem;
    var _a = useHistoryItemAsync(orderId), asyncState = _a[0], actions = _a[1];
    var _b = useState(), body = _b[0], setBody = _b[1];
    var activateHandler = useCallbackRef(function () {
        if (orderId) {
            setBody({
                service: 'taxi',
                order_id: orderId,
                service_request: {
                    taxi: {
                        image_tags: {
                            size_hint: 9999,
                        },
                    },
                },
            });
        }
    });
    useEffect(function () {
        if (historyItem && body) {
            actions.start();
            var cancelRequest_1 = historyItem({
                body: body,
                onSuccess: actions.success,
                onError: actions.error,
            });
            return function () {
                cancelRequest_1();
                actions.reset();
            };
        }
    }, [historyItem, actions, body]);
    return [activateHandler, asyncState];
};
export var useHistoryItemState = function () { return useHistoryItemAsync()[0]; };
